import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/Layout';
import Footer from '../components/Footer';
import Social from '../components/Social';

const PrivacyPolicy = () => (
  <Layout>
    <section className="cta">
      <div className="cta-content">
        <div className="container">
          <h2>
            Terms & Conditions
            <br />
            <Link className="btn btn-outline btn-xl" to="/">
              Go back
            </Link>
          </h2>
        </div>
      </div>
      <div className="overlay"></div>
    </section>
    <section className="privacy" id="privacy">
      <div className="container">
        <div className="section-heading text-center">
          <h1>Samfunns-Statsborgerpøve iOS and Android Terms & Conditions</h1>
          <p>
            <em>Last Edited on 2020-08-22</em>
          </p>
          <hr />
        </div>
        <div className="container-fluid text-muted">
          <p>
            <strong>Introduction</strong>
          </p>
          <p>
            <b>
            By using our mobile applications and placing orders for products, you agree to be bound by these terms.
            </b>
          </p>
          <p>
            <strong>Purchase and Use of the Service</strong>
          </p>
          <p>
            <b>
            When you buy access to the services in the applications you get access to all studying materials. The service shall be available 24 hours/day. However, downtime can occur due to technical maintenance and correction of errors.
            </b>
          </p>
          <p>
            <b>
            All purchases are handled by App Store and Google Play respectively and can be made via any payment methods the stores support.
            </b>
          </p>
          <p>
            <b>
            A purchase is bound to an Apple Id or Google Play account respectively from which it has been made.
It is not possible to transfer the purchase to any another account nor to move the purchase between Android and iOS devices.
            </b>
          </p>
          <p>
            <strong>General Information</strong>
          </p>
          <p>
            <b>
          Learning materials provided are based on <a href="https://samfunnskunnskap.no/" target="_blank" rel="noreferrer noopener">
          samfunnskunnskap.no
              <br />
            </a>
          </b>
          </p>
          <p>
            <strong>Guarantees, Liabilities and Refund</strong>
          </p>
          <p>Samfunn-statsborgerprøve mobile applications serve as an educational material and do not provide any guarantees of the successful passing of Statsborgerprøve and Samfunns­kunnskapsprøve exams.</p>
          <p>We can not be held liable for any results of usage of our services in any way.</p>
          <p>If you for some reason do not pass the exam after practicing using our mobile applications, you are not eligible for the money refund.</p>
          <p>
            <strong>General Conditions</strong>
          </p>
          <p>We will treat all your personal information that we collect in connection with your order in accordance with the terms of our Privacy Policy.</p>
          <p>We reserve the right to refuse service to anyone for any reason at any time.</p>
          <p>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.</p>
          <p>
            <strong>Amendments to Terms & Conditions</strong>
          </p>
          <p>We have the right to amend this Terms & Conditions at any time, without prior notice to each user. Any changes we may make to our Terms & Conditions in the future will be posted here. Where appropriate, we will notify you or seek your consent. Please check back frequently to see any updates or changes to our Terms & Conditions.</p>
          <p>
            <strong>Contact Information</strong>
          </p>
          <p>At any time any questions about our Terms & Conditions you have can be sent to our email address  &nbsp;
            <a href="mailto:samfunnsprove@gmail.com">
              samfunnsprove@gmail.com
            </a>.</p>
        </div>
      </div>
    </section>
    <section className="contact bg-primary" id="contact">
      <div className="container">
        <h2>
          We appreciate your feedback &nbsp;
          <i className="fas fa-heart"></i>
        </h2>
        <Social />
      </div>
    </section>

    <Footer />
  </Layout>
);

export default PrivacyPolicy;
